import { FireTruckIcon } from './FireTruckIcon';

/**
 * author: Nick
 * id 1C8EC9A6-0545-4A59-B9F8-5E498E40529D
 * name fire-truck
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fire-truck.svg
 * tags
 * - Transportation + Road 
 */
export const FireEngineIcon = FireTruckIcon;
export default FireEngineIcon